type Hydrator = (config: any) => HTMLElement;

const REGISTRY: { selector: string; factory: Hydrator }[] = [];

export function registerHydrator(selector: string, factory: Hydrator) {
  REGISTRY.push({ selector, factory });
}

export function rehydrate(root: ParentNode = document) {
  REGISTRY.forEach(({ selector, factory }) => {
    root.querySelectorAll<HTMLElement>(selector).forEach((el) => {
      const cfg = readConfig(el);
      if (!cfg) return;
      const fresh = factory(cfg);
      el.replaceChildren(fresh);
    });
  });
}

function readConfig(el: HTMLElement) {
  try {
    return JSON.parse(el.getAttribute('data-cb-config') || '');
  } catch {
    return null;
  }
}
